module.exports = __webpack_public_path__ + "img/men2-img.9d91bc16.png";